import { Component, Input } from '@angular/core';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { NgTemplateOutlet } from '@angular/common';

@Component({
  selector: 'wl-partial-list-item',
  templateUrl: './list-item.component.html',
  styleUrls: [
    './list-item.component.essent.scss',
    './list-item.component.ed.scss',
  ],
  standalone: true,
  imports: [FaIconComponent, NgTemplateOutlet],
})
export class ListItemComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() label?: string;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() iconLeading?: IconProp;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() iconTrailing?: IconProp;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() active? = false;
}
